import { render, staticRenderFns } from "./CompensationPointsAdmin.vue?vue&type=template&id=331c5ed4&scoped=true&"
import script from "./CompensationPointsAdmin.vue?vue&type=script&lang=js&"
export * from "./CompensationPointsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c5ed4",
  null
  
)

export default component.exports